import React, { useState } from "react";
import I18n from 'i18n.js.erb'
import ErrorModal from "./ErrorModal";
import AddressFormContainerModal from "./AddressFormContainerModal";
import {EMPTY_ADDRESS, isValidUserAddress} from "../../utils/utils";
import AlertPopup from "./AlertPopup";
import SuccessFlashMessage from "./SuccessFlashMessage";
import Address from "./Address";


const IndexShipmentAddresses = ({ shipmentAddresses, countries, user_id }) => {

  const [ shipmentAddressesToRender, setShipmentAddressesToRender ] = useState(JSON.parse(shipmentAddresses))
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false)
  const [ showErrorModal, setShowErrorModal ] = useState(false)
  const [ showAddressFormContainerModal, setShowAddressFormContainerModal ] = useState(false)
  const [ addressToUpdate, setAddressToUpdate ] = useState(null);
  const [ showDeletePopup, setShowDeletePopup ] = useState(false);
  const [ createNewAddress, setCreateNewAddress ] = useState(false);


  // Funzione che permette di modificare un indirizzo dell'utente tramite richiesta http al server,
  // o di settarlo come nuovo indirizzo di default
  const handleUpdateShipmentAddress = (shipmentAddress, ignorePhoneNumber) => {
    if (!shipmentAddress)
      shipmentAddress = addressToUpdate

    if (isValidUserAddress(shipmentAddress, null, ignorePhoneNumber)) {
      const url = `/users/${user_id}/shipment_addresses/${shipmentAddress.id}`;

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(shipmentAddress),
      })
        .then((response) => {
          setShowAddressFormContainerModal(false)
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((data) => {
          let newShipmentAddresses = []
          if (shipmentAddress.deleted)
            newShipmentAddresses = shipmentAddressesToRender.filter((address) => address.id !== shipmentAddress.id)
          else {
            newShipmentAddresses = shipmentAddressesToRender.map((address) => {
              let newAddress = { ...address }
              if (address.id === shipmentAddress.id) {
                newAddress = shipmentAddress;
              } else {
                if (shipmentAddress.is_default)
                  newAddress["is_default"] = false;
                if (shipmentAddress.residence)
                  newAddress["residence"] = false;
              }
              return newAddress;
            });
          }
          setShipmentAddressesToRender(newShipmentAddresses);
          setShowSuccessFlashMessage(true)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette all'utente di creare un nuovo indirizzo tramite richiesta http al server
  const handleCreateShipmentAddress = (shipmentAddress) => {
    if (!shipmentAddress)
      shipmentAddress = addressToUpdate

    if (isValidUserAddress(shipmentAddress)) {
      const url = `/users/${user_id}/shipment_addresses`;

      if (shipmentAddressesToRender.length === 0)
        shipmentAddress['is_default'] = 'default'

      fetch(url + ".json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(shipmentAddress),
      })
        .then((response) => {
          setShowAddressFormContainerModal(false)
          setCreateNewAddress(false)
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((data) => {
          const newShipmentAddress = {
            ...shipmentAddress,
            id: data,
            can_be_updated: true,
            deleted: false,
            is_default: shipmentAddressesToRender.length === 0
          };
          if (shipmentAddress.residence)
            setShipmentAddressesToRender([
              ...shipmentAddressesToRender.map(address => {
                return {...address, residence: false}
              }),
              newShipmentAddress
            ]);
          else
            setShipmentAddressesToRender([ ...shipmentAddressesToRender, newShipmentAddress ]);
          setShowSuccessFlashMessage(true);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che setta l'indirizzo dell'utente da modificare e apre la modale che consente di aggiornarne i campi
  const handleOpenAddressFormContainerModal = (shipmentAddress, createAddress) => {
    setCreateNewAddress(createAddress)
    setAddressToUpdate(shipmentAddress);
    setShowAddressFormContainerModal(true)
  }


  // Funzione che permette di aggiornare i vari campi che compongono l'indirizzo di spedizione
  // con i dati immessi dall'utente sull'interfaccia grafica
  const updateShipmentAddressParams = (keys, values) => {
    const newAddress = {...addressToUpdate}
    for (let i = 0; i < keys.length; i++)
      newAddress[keys[i]] = values[i]
    setAddressToUpdate(newAddress)
  }


  // Funzione che apre il popup di conferma eliminazione di un indirizzo
  const openDeletePopup = (shipmentAddress) => {
    setAddressToUpdate(shipmentAddress)
    setShowDeletePopup(true);
  }


  // Funzione che permette all'utente di eliminare uno specifico indirizzo
  // (si tratta di una cancellazione logica e non fisica sul db)
  const onDeleteHandler = () => {
    if (!addressToUpdate.is_default)
      handleUpdateShipmentAddress({ ...addressToUpdate, deleted: true }, true);
  }



  const Buttons = ({shipmentAddress}) => {
    return <React.Fragment>
      {
        shipmentAddress.can_be_updated &&
        <img src={window.location.origin + '/images/icons/edit.svg'}
             width="15" className="cursor-pointer" alt=""
             id={`edit_shipment_address_${shipmentAddress.id}`}
             onClick={(e) => handleOpenAddressFormContainerModal(shipmentAddress, false)} />
      }

      {
        !shipmentAddress.is_default &&
        <img src={window.location.origin + '/images/icons/trash.svg'}
             width="15" className="cursor-pointer ml-3" alt=""
             id={`delete_shipment_address_${shipmentAddress.id}`}
             onClick={(e) => openDeletePopup(shipmentAddress)} />
      }
    </React.Fragment>
  }



  return <React.Fragment>
    {
      shipmentAddressesToRender && shipmentAddressesToRender.length > 0 ?
        <React.Fragment>
          {
            shipmentAddressesToRender.map((shipmentAddress) => {
              return <div key={shipmentAddress.id}
                          className={`row ${shipmentAddress.is_default ? 'bg-aig-gradient-light' : ''} border-aiG-light-gray-imp br-20px mx-0 my-5 py-3 shadow`}>
                <div className="col-12 col-md-6">
                  <div className="d-flex d-md-none justify-content-end mt-0 mb-3">
                    <Buttons
                      shipmentAddress={shipmentAddress}
                    />
                  </div>
                  <Address
                    renderResidence={true}
                    address={shipmentAddress}
                  />
                </div>
                <div className="col-12 col-md-6 d-flex flex-directions-column justify-content-between pt-1">
                  <div className="d-none d-md-flex justify-content-end mt-3 mt-md-0 mb-3">
                    <Buttons
                      shipmentAddress={shipmentAddress}
                    />
                  </div>

                  <div className="d-flex justify-content-md-end">
                    {
                      !shipmentAddress.is_default ?
                        <button id={`set_as_default_shipment_address_${shipmentAddress.id}`}
                                name={`set_as_default_shipment_address_${shipmentAddress.id}`}
                                className="standard-cta-reverse font-size-14px br-50px py-1 px-4 d-flex align-items-center justify-content-center mt-3 mt-md-0"
                                onClick={() => handleUpdateShipmentAddress({ ...shipmentAddress, is_default: true }, true)}
                        >
                          {I18n.t('js.indexShipmentAddressesPage.setAsDefault').toUpperCase()}
                        </button>
                      :
                        <span className="text-intense-blue text-weight-500">
                          {I18n.t('js.indexShipmentAddressesPage.defaultAddress')}
                        </span>
                    }
                  </div>
                </div>
              </div>
            })
          }
        </React.Fragment>
      :
        <div className="d-flex justify-content-center">
          <div className="d-flex align-items-center text-muted ml-md-3 mr-md-3 mt-md-4 text-center text-space">
            <b className="ml-2">{I18n.t('js.indexShipmentAddressesPage.noResultsFound')}</b>
          </div>
        </div>
    }

    <div className="d-flex justify-content-center mt-5 pt-3">
      <button type="button" id="addAddressBtn"
              className="btn bg-aig-gradient br-50px border-none text-light py-2 px-4 font-weight-bold mt-3 mt-md-0"
              onClick={(e) => handleOpenAddressFormContainerModal(EMPTY_ADDRESS, true) }>
        {`${I18n.t('js.indexShipmentAddressesPage.addAddress').toUpperCase()}`}
      </button>
    </div>


    <SuccessFlashMessage
      showSuccessFlashMessage={showSuccessFlashMessage}
      setShowSuccessFlashMessage={setShowSuccessFlashMessage}
    />

    <ErrorModal
      showErrorModal={showErrorModal}
      setShowErrorModal={setShowErrorModal}
    />

    <AddressFormContainerModal
      showModal={showAddressFormContainerModal}
      setShowModal={setShowAddressFormContainerModal}
      shipmentAddress={addressToUpdate}
      updateShipmentAddressParams={updateShipmentAddressParams}
      countries={countries}
      updateShipmentAddress={!createNewAddress ? handleUpdateShipmentAddress : handleCreateShipmentAddress}
      createNewAddress={createNewAddress}
      canUpdate={true}
      addressType={'user'}
    />


    <AlertPopup
      showAlertPopup={showDeletePopup}
      onSuccess={onDeleteHandler}
      onDiscard={setShowDeletePopup}
      popupTitle={`${I18n.t('js.indexShipmentAddressesPage.alertPopupDeleteShipmentAddressTitle')}`}
      popupContent={`${I18n.t('js.indexShipmentAddressesPage.alertPopupDeleteShipmentAddressContent')}`}
      cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
      confirmButtonText={`${I18n.t('js.common.button.delete').toUpperCase()}`}
    />
  </React.Fragment>

};

export default IndexShipmentAddresses;